import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';

export function IrancharsouqAdminRoute({ children }) {
  const { user, loading, activeRole } = useAuth();
  const location = useLocation();

  if (loading) return <div className="dashboard-loading">در حال بارگذاری...</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (activeRole !== 'irancharsouq_admin') return <Navigate to="/unauthorized" replace />;

  return children;
}
